import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Hero from '../components/Hero';
import { getService, getHeroes, getProjects } from '../services/api';
import './ServiceDetail.css';

const ServiceDetail = () => {
  const { serviceKey } = useParams();
  const [service, setService] = useState(null);
  const [hero, setHero] = useState(null);
  const [relatedProjects, setRelatedProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const heroKeys = {
    'audio-video': 'services-av',
    'cctv': 'services-cctv',
    'automation': 'services-automation',
    'software': 'services-software'
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [serviceData, heroData, projectsData] = await Promise.all([
          getService(serviceKey),
          getHeroes(),
          getProjects({ service: serviceKey, limit: 3 })
        ]);
        setService(serviceData);
        setHero(heroData[heroKeys[serviceKey]]);
        setRelatedProjects(projectsData);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [serviceKey]);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!service) {
    return <div className="not-found">Service not found</div>;
  }

  return (
    <div className="service-detail-page">
      <Hero
        title={service.title}
        subtitle={service.short_description}
        backgroundImage={hero?.image_url || service.image_url}
        ctaText="Get Quote"
        ctaLink="/contact"
        height="medium"
        overlay={0.7}
      />

      <section className="section">
        <div className="container">
          <div className="service-detail-content">
            <div className="service-description">
              <h2>Overview</h2>
              <p>{service.full_description || service.short_description}</p>
            </div>

            {service.features && service.features.length > 0 && (
              <div className="service-features-detail">
                <h2>What We Offer</h2>
                <div className="features-grid">
                  {service.features.map((feature, i) => (
                    <div className="feature-item" key={i}>
                      <span className="feature-check">✓</span>
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {relatedProjects.length > 0 && (
        <section className="section section-gray">
          <div className="container">
            <div className="section-title">
              <h2>Related Projects</h2>
              <p>See our work in this area</p>
            </div>
            <div className="related-projects-grid">
              {relatedProjects.map(project => (
                <Link to={`/portfolio/${project.slug}`} className="related-project-card" key={project.id}>
                  <div 
                    className="project-image"
                    style={{ backgroundImage: `url(${project.featured_image_url || 'https://via.placeholder.com/400x300'})` }}
                  />
                  <div className="project-info">
                    <h3>{project.title}</h3>
                    <span className="view-link">View Project →</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}

      <section className="cta-section">
        <div className="container">
          <h2>Ready to Get Started?</h2>
          <p>Contact us for a free consultation and quote</p>
          <Link to="/contact" className="btn btn-primary">Contact Us</Link>
        </div>
      </section>
    </div>
  );
};

export default ServiceDetail;
